/**
 * 订单状态
 */
export enum OrderStatus {
  /**
   * 待卖家确认
   */
  WAIT_SELLER_CONFIRM = 0,

  /**
   * 待买家确认
   */
  WAIT_BUYER_CONFIRM = 1,

  /**
   * 申请调价
   */
  ADJUST_PRICE = 2,

  /**
   * 待付款
   */
  WAIT_PAY = 3,

  /**
   * 待发货
   */
  WAIT_DELIVERY = 4,

  /**
   * 待收货
   */
  WAIT_RECEIVE = 5,

  /**
   * 已完成
   */
  FINISH = 6,

  /**
   * 已取消
   */
  CANCEL = 7
}

/**
 * 买方看到的状态文本
 */
export const OrderStatusBuyerTextMap: Record<OrderStatus, string> = {
  [OrderStatus.WAIT_SELLER_CONFIRM]: '待卖家确认',
  [OrderStatus.WAIT_BUYER_CONFIRM]: '待确认',
  [OrderStatus.ADJUST_PRICE]: '待确认',
  [OrderStatus.WAIT_PAY]: '待付款',
  [OrderStatus.WAIT_DELIVERY]: '待发货',
  [OrderStatus.WAIT_RECEIVE]: '待收货',
  [OrderStatus.FINISH]: '已完成',
  [OrderStatus.CANCEL]: '已取消'
}

/**
 * 卖方看到的状态文本
 */
export const OrderStatusSellerTextMap: Record<OrderStatus, string> = {
  [OrderStatus.WAIT_SELLER_CONFIRM]: '待确认',
  [OrderStatus.WAIT_BUYER_CONFIRM]: '待买家确认',
  [OrderStatus.ADJUST_PRICE]: '待买家确认',
  [OrderStatus.WAIT_PAY]: '待付款',
  [OrderStatus.WAIT_DELIVERY]: '待发货',
  [OrderStatus.WAIT_RECEIVE]: '待收货',
  [OrderStatus.FINISH]: '已完成',
  [OrderStatus.CANCEL]: '已取消'
}

export const OrderStatusColorMap: Record<OrderStatus, string> = {
  [OrderStatus.WAIT_SELLER_CONFIRM]: 'default',
  [OrderStatus.WAIT_BUYER_CONFIRM]: 'default',
  [OrderStatus.ADJUST_PRICE]: 'default',
  [OrderStatus.WAIT_PAY]: 'processing',
  [OrderStatus.WAIT_DELIVERY]: 'processing',
  [OrderStatus.WAIT_RECEIVE]: 'processing',
  [OrderStatus.FINISH]: 'success',
  [OrderStatus.CANCEL]: 'default'
}
